import React from 'react';
import { ErrorBoundary } from '@components/error';
import { UserType } from '@constants/app';
import { UserAuthContextValue, UserAuthContext } from './UserAuthContext';
import { tryUntilTrue } from '@utils/data';

type Props = React.PropsWithChildren<UserAuthContextValue>;

export const UserAuthProvider: React.FC<Props> = ({ authInfo, children }) => {
  const providerValue = React.useMemo(() => ({ authInfo }), [authInfo])

  React.useEffect(() => {
    tryUntilTrue(() => {
      if (
        authInfo?.authState
        && ErrorBoundary.bugsnagClient
      ) {
        ErrorBoundary.bugsnagClient.addMetadata('user', {
          userType: UserType.USER,
          tenant: authInfo.authState.organization.tenant,
        })
        ErrorBoundary.bugsnagClient.setUser(
          authInfo.authState.participant._id,
          authInfo.authState.participant.email,
          authInfo.authState.participant.name,
        )
      }
      return !!ErrorBoundary.bugsnagClient
    });
  }, [authInfo])

  return (
    <UserAuthContext.Provider value={providerValue}>
      {children}
    </UserAuthContext.Provider>
  )
}